import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const { RangePicker } = DatePicker;

const yearFormat = "YYYY";

const TimePicker = ({
  min,
  max,
  value,
  setValue,
  selectedKeywords,
  setSelectedKeywords,
  disabled,
}) => {
  const [openPicker, setOpenPicker] = useState(false);
  const [valueTemp, setValueTemp] = useState(value);

  const handleRangeChange = (value, dateString) => {
    setValueTemp(dateString);
    if (openPicker == false) {
      setValue(dateString);
    }
  };
  const commitValue = () => {
    setOpenPicker(false);
  };
  const defaultFromYear = 1960;
  const defaultToYear = new Date().getFullYear();

  const defaultRange = [
    dayjs(defaultFromYear.toString(), yearFormat),
    dayjs(defaultToYear.toString(), yearFormat),
  ];
  const footerStyle = {
    display: "flex",
    justifyContent: "flex-end",
  };
  const buttonStyle = {
    margin: "5px",
  };

  return (
    <div>
      <RangePicker
        style={{ width: 150 }}
        allowClear={false}
        picker="year"
        open={openPicker}
        disabled={disabled}
        onOpenChange={() => setOpenPicker(true)}
        onPanelChange={setValueTemp}
        defaultValue={defaultRange}
        value={
          valueTemp && [
            valueTemp[0] ? dayjs(valueTemp[0].toString(), yearFormat) : null,
            valueTemp[1] ? dayjs(valueTemp[1].toString(), yearFormat) : null,
          ]
        }
        onChange={(value, dateString) => handleRangeChange(value, dateString)}
        renderExtraFooter={() => (
          <div style={footerStyle}>
            <Button
              style={buttonStyle}
              type="primary"
              onClick={() => {
                commitValue();
              }}
            >
              OK
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default TimePicker;
